import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';
import { MiniDriver } from './mini-driver';

@inheritSerialization(AbstractModel)
export class DriverProfileStatus extends AbstractModel {
  @autoserialize
  stateCode: string;

  @autoserializeAs(MiniDriver)
  miniDriver: MiniDriver;

  @autoserialize
  status: string;
}
